import { useRef, useState } from 'react';
import useStore from '../stores/store';
import { v1 as uuidv1 } from 'uuid';
import {
    AlertDialog,
    useColorMode,
    useColorModeValue,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogCloseButton,
    AlertDialogBody,
    AlertDialogFooter,
    Button,
    Input,
    InputGroup,
    InputLeftAddon,
    Text,
    useDisclosure,
    Icon,
    Box,
    Image,
    SimpleGrid,
    Tooltip
} from '@chakra-ui/react';
import { TabData } from 'types';
import { favIconFetchGoogle } from '../Utils/favIconUtils';
import { isTrialReached } from './userApi';
import useCustomToast from './ToastProvider';
const Calendar = '../../assets/images/calendar.png';
const Docs = '../../assets/images/docs.png';
const Excel = '../../assets/images/excel.png';
const Figma = '../../assets/images/figma.png';
const Form = '../../assets/images/forms.png';
const Github = '../../assets/images/github.png';
const Medium = '../../assets/images/medium.png';
const Meet = '../../assets/images/meet.png';
const Notion = '../../assets/images/notion.png';
const Photoshop = '../../assets/images/photoshop.png';
const Powerpoint = '../../assets/images/powerpoint.png';
const Sheets = '../../assets/images/sheets.png';
const Slides = '../../assets/images/slides.png';
const Spotify = '../../assets/images/spotify.png';
const Twitter = '../../assets/images/twitter.png';
const Word = '../../assets/images/word.png';

export const isImage = (url: string): boolean => {
    // Check direct image extensions
    if (url.match(/\.(jpeg|jpg|gif|png)$/i)) return true;
    
    // Check for image service URLs
    if (url.includes('/_next/image') ||    // Next.js image
        url.includes('/images/') ||        // Common image path
        url.includes('images.unsplash.com') || // Unsplash
        url.match(/\.(jpeg|jpg|gif|png)/i) || // Image extension anywhere in URL
        (url.includes('&w=') && url.includes('&q=')) || // Image resize parameters
        url.includes('ixlib=') // Unsplash and similar image services
    ) return true;
    
    return false;
};

const OpenSitesDialog = ({ closeSiteDialog, groupId }) => {
    //Zustate
    const tabs = useStore.getState().tabGroups;
    //const tabs = useStore(tabsZu);
    //const setTabs = useStore(setTabsZu);
    //const setLimitDialogOpen = useStore(setLimitDialogOpenZu); //TODO show limit modal
    const userData = useStore((state) => state.userData);
    const [errors, setErrors] = useState({ siteTitle: false, siteUrl: false });
    //Colorstuff
    const { colorMode } = useColorMode();
    const color = useColorModeValue('#FFF', '#262A2D');
    const icon = useColorModeValue('gray.500', '#A1A2A4');
    const input = useColorModeValue('gray.200', '#A1A2A4');
    const text = useColorModeValue('#1A202C', '#FFF');
    const secondaryButton = useColorModeValue('solid', 'outline');
    const errorColor = useColorModeValue('red.500', '#FFF');
    const iconColor = useColorModeValue('gray.600', '#B3BAC6');
    const subTitle = useColorModeValue('gray.600', '#A1A2A4');

    //const { isOpen, onOpen, onClose } = useDisclosure();
    const cancelRef = useRef();
    let trailimitReached = isTrialReached();
    const showToast = useCustomToast();
    //let favIconUrl = "chrome://favicon/size/16@3x/" + a.url;

    const onSubmit = (event) => {
        event.preventDefault();
        if (trailimitReached) {
            showToast({
                title: 'Limit reached',
                type: 'info',
                subtitle:
                    'You have reached the maximum saved sites on the free plan.',
                resClick: null
            });
            return;
        }
        const data: any = new FormData(event.target);
        const siteTitle = data.get('siteTitle');
        const siteUrl = data.get('siteUrl');

        let urlFromInput;
        let favIconUrl;
        if (siteUrl.substring(0, 8) === 'slack://') {
            urlFromInput = siteUrl;
            favIconUrl = favIconFetchGoogle(urlFromInput);
        } else if (siteUrl.substring(0, 9) === 'chrome://') {
            urlFromInput = siteUrl;
            favIconUrl = favIconFetchGoogle(urlFromInput);
        } else if (siteUrl.substring(0, 8) === 'file:///') {
            urlFromInput = siteUrl;
            favIconUrl = 'localIcon';
        } else {
            let cleanUrl = siteUrl.replace('https://', '');
            urlFromInput = 'https://' + cleanUrl; /* + "/"; */
            favIconUrl = favIconFetchGoogle(urlFromInput);
        }
        //TODO Logic to add file
        AddSite(siteTitle, urlFromInput, false, favIconUrl);
    };

    const addShortcut = (title, url) => {
        if (trailimitReached) {
            showToast({
                title: 'Limit reached',
                type: 'info',
                subtitle:
                    'You have reached the maximum saved sites on the free plan.',
                resClick: null
            });
            return;
        }
        AddSite(title, url, true);
        closeSiteDialog();
    };

    const AddSite = (title, url, preDefined, favIconUrl = null) => {
        const imageDetected = isImage(url);       
        let newId = uuidv1();
        let dateobj = new Date().toString();
        let dateCreated = dateobj;
        let newData = [...tabs];
        let spaceIndex = newData.findIndex((target) => target.id === groupId);
        let newTabs = [
            ...newData[spaceIndex].tabs,
            {
                id: newId,
                title: title,
                favIcon: preDefined ? 'localIcon' : favIconUrl,
                url: url,
                comment: '',
                commentColor: false,
                note: false,
                dateCreated: dateCreated,
                imageUrl: imageDetected ? url : null
            }
        ];
        newData[spaceIndex].tabs = newTabs;
        useStore
            .getState()
            .updateTabGroups(newData, { type: 'items', ids: [newId] });
        closeSiteDialog();
    };

    const newLinksArr = [
        {
            title: 'Calendar',
            subtitle: 'New event in Google Calendar',
            url: 'https://cal.new',
            icon: Calendar
        },
        {
            title: 'Docs',
            subtitle: 'New Google doc',
            url: 'https://docs.new',
            icon: Docs
        },
        {
            title: 'Meet',
            subtitle: 'Start new Google Meeting',
            url: 'https://meet.new',
            icon: Meet
        },
        {
            title: 'Form',
            subtitle: 'Create new Google form',
            url: 'https://forms.new',
            icon: Form
        },
        {
            title: 'Sheets',
            subtitle: 'Create new Google Sheet',
            url: 'https://sheets.new',
            icon: Sheets
        },
        {
            title: 'Slides',
            subtitle: 'Create new Google Slide project',
            url: 'https://slides.new',
            icon: Slides
        },

        {
            title: 'Figma',
            subtitle: 'Create Figma file',
            url: 'https://figma.new',
            icon: Figma
        },
        {
            title: 'Github',
            subtitle: 'Create new Github repository',
            url: 'https://github.new',
            icon: Github
        },
        {
            title: 'Spotify',
            subtitle: 'Create new playlist in Spotify',
            url: 'https://playlist.new',
            icon: Spotify
        },
        {
            title: 'Medium',
            subtitle: 'Write new post',
            url: 'https://story.new',
            icon: Medium
        },
        {
            title: 'Photoshop',
            subtitle: 'Create new Adobe Photoshop file',
            url: 'https://photo.new',
            icon: Photoshop
        },
        {
            title: 'Notion',
            subtitle: 'Create new page',
            url: 'https://notion.new',
            icon: Notion
        },
        {
            title: 'Twitter',
            subtitle: 'Write a new tweet',
            url: 'https://twitter.com/intent/tweet',
            icon: Twitter
        },
        {
            title: 'Word',
            subtitle: 'Create new Microsoft Word document',
            url: 'https://word.new',
            icon: Word
        },
        {
            title: 'Powerpoint',
            subtitle: 'Create new Microsoft Powerpoint',
            url: 'https://powerpoint.new',
            icon: Powerpoint
        },
        {
            title: 'Excel',
            subtitle: 'Create new Microsoft Excel',
            url: 'https://excel.new',
            icon: Excel
        }
    ];

    return (
        <>
            <AlertDialog
                leastDestructiveRef={cancelRef}
                onClose={closeSiteDialog}
                isOpen={true}
            >
                <AlertDialogOverlay style={{ backdropFilter: 'blur(1px)' }} />
                <AlertDialogContent
                    rounded="9px"
                    bg={color}
                    px="2rem"
                    minW="576px"
                >
                    <AlertDialogHeader
                        pt="2.5rem"
                        px="0rem"
                        pb="8px"
                        textAlign="left"
                        color={text}
                    >
                        <Text>Add a custom url</Text>
                        <Text
                            fontSize="12px"
                            color={subTitle}
                            mt="8px"
                            opacity={0.75}
                        >
                            You can also use file:/// to link to local files
                        </Text>
                    </AlertDialogHeader>
                    <AlertDialogCloseButton
                        top="1.25rem"
                        right="1.5rem"
                        color={icon}
                        transition="0s"
                    />
                    <form
                        onSubmit={(event) => onSubmit(event)}
                        style={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <InputGroup mt="12px">
                            <Input
                                required
                                color={text}
                                focusBorderColor="#63B3ED"
                                variant="filled"
                                type="text"
                                name="siteTitle"
                                placeholder="Title"
                                className={
                                    colorMode === 'light'
                                        ? 'signup'
                                        : 'signupdark'
                                }
                                rounded="8px"
                            />
                        </InputGroup>
                        {errors.siteTitle && (
                            <Text color={errorColor} mt="4px">
                                Title of site is required
                            </Text>
                        )}
                        <InputGroup mt="12px">
                            <InputLeftAddon children="https://" bg={input} />
                            <Input
                                required
                                //size="sm"
                                color={text}
                                focusBorderColor="#63B3ED"
                                variant="filled"
                                type="text"
                                name="siteUrl"
                                placeholder="www..."
                                className={
                                    colorMode === 'light'
                                        ? 'signup'
                                        : 'signupdark'
                                }
                                roundedLeft="0px"
                                roundedRight="8px"
                            />
                        </InputGroup>
                        {errors.siteUrl && (
                            <Text color={errorColor} mt="4px">
                                Url of site is required
                            </Text>
                        )}
                        <Button
                            type="submit"
                            isDisabled={trailimitReached}
                            w="100%"
                            size="md"
                            color="#FFF"
                            mt="16px"
                            mb="32px"
                            ml="auto"
                            rounded="8px"
                            backgroundImage="linear-gradient(145deg, #5DABFE 0%, #3391FF 100%)"
                            _hover={{
                                backgroundImage:
                                    'linear-gradient(145deg, #3592FE 0%, #2E7EDB 100%)',
                                boxShadow:
                                    '0 10px 16px -8px rgba(49, 144, 255,0.5)'
                            }}
                            boxShadow="0 12px 18px -10px rgba(49, 144, 255,0.35)"
                            transition="all 0.12s"
                        >
                            <PlusIcon />
                            Add site/image
                        </Button>
                    </form>
                    <Text color={subTitle} mb="16px" fontSize="12px">
                        Or add a predefined <b>.new </b>
                        shortcut to the group:
                    </Text>
                    <SimpleGrid columns={8} spacing="32px" pb="32px">
                        {newLinksArr.map((item, index) => (
                            <ShortcutFavIcon
                                key={index}
                                title={item.title}
                                subtitle={item.subtitle}
                                url={item.url}
                                addShortcut={addShortcut}
                                icon={item.icon}
                            />
                        ))}
                    </SimpleGrid>
                </AlertDialogContent>
            </AlertDialog>
        </>
    );
};

const PlusIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="#FFF"
            style={{ width: '16px', height: '16px' }}
        >
            <path
                fillRule="evenodd"
                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default OpenSitesDialog;

const ShortcutFavIcon = ({ title, subtitle, url, addShortcut, icon }) => {
    const favIconBg = useColorModeValue('#FFF', 'transparent');
    const outerShadow = useColorModeValue(
        '0 1px 4px -1px rgba(78,80,81,0.44)',
        ''
    );
    const hoverShadow = useColorModeValue(
        '0 4px 8px 0px rgb(135 145 155 / 36%), 0 0px 0px 1px rgb(135 145 155 / 8%)',
        '0 3px 10px -3px rgba(0,0,0,0.90), 0 0px 0px 1px rgb(0 0 0 / 20%)'
    );

    return (
        <Tooltip
            placement="bottom"
            zIndex="500000"
            rounded="6px"
            px="12px"
            py="6px"
            openDelay={200}
            label={
                <>
                    <Box>
                        <Text
                            fontWeight="bold"
                            letterSpacing="0.64px"
                            fontSize="16px"
                        >
                            {title}
                        </Text>
                        <Text
                            fontSize="14px"
                            opacity="0.8"
                            wordBreak="break-all"
                            //isTruncated
                        >
                            {subtitle}
                        </Text>
                        <Text
                            fontSize="12px"
                            opacity="0.6"
                            mt="2px"
                            wordBreak="break-all"
                            //isTruncated
                        >
                            {url}
                        </Text>
                    </Box>
                </>
            }
        >
            <Box
                cursor="pointer"
                display="flex"
                alignItems="center"
                rounded="6px"
                h="36px"
                minW="36px"
                maxW="36px"
                minH="36px"
                bg={favIconBg}
                boxShadow={outerShadow}
                _hover={{
                    boxShadow: hoverShadow,
                    transform: 'scale(1.075)'
                }}
                _active={{
                    boxShadow: outerShadow,
                    transform: 'scale(0.975)'
                }}
                willChange={'transform'}
                mr="0px"
                ml="0px"
                //my="6px"
                transition={'0.16s cubic-bezier(0.22,0.61,0.36,1)'}
                position="relative"
                onClick={() => addShortcut(title, url)}
                p="2px"
            >
                <Image
                    src={icon}
                    h="25px"
                    w="25px"
                    maxW="25px"
                    maxH="25px"
                    minW="25px"
                    m="auto"
                    alt="shortcut"
                    rounded="4px"
                    textAlign="center"
                    willChange="transform"
                />
            </Box>
        </Tooltip>
    );
};
